"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
var react_1 = __importDefault(require("react"));
var truncate_1 = __importDefault(require("lodash/truncate"));
var system_1 = require("../../../system");
var Box_1 = require("../../Box");
var Typography_1 = require("../../Typography");
var Go_1 = require("../Go");
var hooks_1 = require("./hooks");
var useStyles = (0, system_1.makeStyles)(function () { return ({
    root: {
        height: 28,
        '& > div': {
            height: '100%',
        },
        '& img': {
            height: '100%',
        },
    },
    logoIcon: {
        marginLeft: 6,
        width: 32,
        height: 32,
    },
    root_hideClient: {
        '& > div:not(:first-child)': {
            display: 'none',
        },
    },
    cross: {
        '$root &': {
            lineHeight: '32px',
            fontWeight: 500,
            fontSize: 26,
            paddingTop: 1,
        },
    },
    clientName: {
        '$root &': {
            lineHeight: '28px',
            fontWeight: 500,
            fontSize: 21,
            paddingTop: 1,
            whiteSpace: 'nowrap',
        },
    },
}); });
var Logo = function (_a) {
    var yandexName = _a.yandexName, clientName = _a.clientName, _b = _a.hasGoIcon, hasGoIcon = _b === void 0 ? false : _b;
    var classes = useStyles();
    var truncatedName = (0, truncate_1.default)(clientName, { length: 32 });
    var yandexLogo = (0, hooks_1.useLogoImage)(yandexName);
    return (react_1.default.createElement(Box_1.Box, { flexWrap: "nowrap", className: classes.root },
        react_1.default.createElement(Box_1.Box, { alignItems: "center", flexWrap: "nowrap" },
            react_1.default.createElement("img", { src: yandexLogo, alt: yandexName }),
            hasGoIcon && react_1.default.createElement(Go_1.GoIcon, { className: classes.logoIcon })),
        clientName && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Box_1.Box, { pr: "S", pl: "S" },
                react_1.default.createElement(Typography_1.Typography, { className: classes.cross, component: "span", variant: "title" }, "\u00D7")),
            react_1.default.createElement(Box_1.Box, { display: "block" },
                react_1.default.createElement(Typography_1.Typography, { className: classes.clientName, component: "span", variant: "title" }, truncatedName))))));
};
exports.Logo = Logo;
